module.exports = __webpack_public_path__ + "static/media/notification-white.320e01bd.svg";